








































































































































































































































import Vue from 'vue';


export default Vue.extend({
  name: 'RandomQuestions',

  data() {
    return {
      // https://vuetifyjs.com/en/styles/colors/#colors
      categoriesColors: [
        { color: 'grey', text: 'Almenn kunnátta' },
        { color: 'green darken-1', text: 'Náttúra og vísindi' },
        { color: 'brown darken-1', text: 'Bókmenntir og listir' },
        { color: 'yellow darken-2', text: 'Saga' },
        { color: 'blue darken-1', text: 'Landafræði' },
        { color: 'pink darken-1', text: 'Skemmtun og afþreying' },
        { color: 'brown darken-1', text: 'Íþróttir og tómstundir' },
      ],
    };
  },

  computed: {
    randomQuestions() {
      return this.$store.getters.randomQuestions;
    },
    queryCount(): number {
      return this.$store.getters.queryCount;
    },
  },

  methods: {
    selectQuestion(id: number): void {
      this.$store.dispatch('selectQuestion', id);
    },
    showAnswer(id: number): void {
      this.$store.dispatch('showAnswer', id);
    },
    showAllAnswers(): void {
      this.$store.dispatch('showAllAnswers');
    },
    selectAllQuestions(): void {
      this.$store.dispatch('selectAllQuestions');
    },
    getCategoryColor(id: number): string {
      return this.categoriesColors[id - 1].color;
    },
    getCategoryText(id: number): string {
      return this.categoriesColors[id - 1].text;
    },

  },

});
